import { UiTheme } from '../../theme'

export default (theme: UiTheme) => ({
  wrapper: {
    base: {
      position: 'fixed',
      display: 'flex',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      paddingTop: theme.settings.spacing.large,
      paddingRight: '20px',
      paddingBottom: '70px',
      paddingLeft: theme.settings.spacing.large,
      zIndex: theme.settings.zLayers.topmost,
      alignItems: 'flex-end',
      pointerEvents: 'none',
    },
  },

  innerWrapper: {
    base: {
      display: 'flex',
      flex: 1,
      alignItems: 'flex-end',
      flexDirection: 'column',
    },
  },

  snackbar: {
    base: {
      marginTop: theme.settings.spacing.large,
      pointerEvents: 'auto',
    },
  },
})
